import { useState } from 'react'
import { Box, Collapse, IconButton, Typography, useTheme } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import {
  ESettingsTgSendMsgPermissionsFields,
  ISettingsTgSendMsgPermissionsPayload,
  IUpdateTgSendMessagePermissionsDto,
} from 'src/types'
import { TgSendMessagePermissionsItem } from './tg-send-message-permissionsItem'
import { useUpdateTgSendMsgPermissions } from 'src/hooks'

interface IProps {
  payload?: ISettingsTgSendMsgPermissionsPayload
}

export const TgSendMessagePermissions = ({ payload }: IProps) => {
  const theme = useTheme()

  const [openCollapse, setOpenCollapse] = useState(false)

  const { mutate: updateTgSendMsgPermissions } = useUpdateTgSendMsgPermissions()

  if (!payload) {
    return
  }

  const handleUpdatePayload = (dto: IUpdateTgSendMessagePermissionsDto) => {
    updateTgSendMsgPermissions(dto)
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <IconButton onClick={() => setOpenCollapse(!openCollapse)}>
          <ExpandMoreIcon
            sx={{
              transform: openCollapse ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
            }}
          />
        </IconButton>

        <Typography
          sx={{
            fontSize: 'inherit',
            fontWeight: 'inherit',
          }}
        >
          {'Send Message Permissions'}
        </Typography>
      </Box>

      <Collapse in={openCollapse} sx={{ width: '100%' }}>
        <TgSendMessagePermissionsItem
          field={ESettingsTgSendMsgPermissionsFields.MENTION_REPLY}
          label="Answer to Mentions"
          handleUpdate={handleUpdatePayload}
          payload={payload}
          adittionalText={
            <Typography
              fontSize={'11px'}
              sx={{ color: theme.palette.custom.grey2, textAlign: 'center' }}
            >
              Uses Web Chat Bot
            </Typography>
          }
        />
        <TgSendMessagePermissionsItem
          field={ESettingsTgSendMsgPermissionsFields.APPROVED_DAILY_SUMMARY}
          label="Daily Scan Approved Summary"
          handleUpdate={handleUpdatePayload}
          payload={payload}
        />
        <TgSendMessagePermissionsItem
          field={ESettingsTgSendMsgPermissionsFields.SCAN_APPPROVAL_NOTIFICATION}
          label="Scan Creation Notification"
          handleUpdate={handleUpdatePayload}
          payload={payload}
        />
      </Collapse>
    </Box>
  )
}
